import React from 'react';

const Loader = ({ size = 'md', color = 'blue' }) => {
  let sizeClass = 'h-6 w-6';
  
  if (size === 'sm') {
    sizeClass = 'h-4 w-4';
  } else if (size === 'lg') {
    sizeClass = 'h-8 w-8';
  } else if (size === 'xl') {
    sizeClass = 'h-12 w-12';
  }
  
  let colorClass = 'text-blue-600';
  
  if (color === 'white') {
    colorClass = 'text-white';
  } else if (color === 'gray') {
    colorClass = 'text-gray-600';
  }
  
  return (
    <svg 
      className={`animate-spin ${sizeClass} ${colorClass}`} 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24"
    >
      <circle 
        className="opacity-25" 
        cx="12" 
        cy="12" 
        r="10" 
        stroke="currentColor" 
        strokeWidth="4"
      ></circle>
      <path 
        className="opacity-75" 
        fill="currentColor" 
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
};

export default Loader;